import _ from 'lodash';

export default function requiredValidation(requiredFields, values) {
  const errors = {};

  _.forEach(requiredFields, (requiredField) => {
    const isFalsy = !values[requiredField];
    const isZero = values[requiredField] === 0;

    if (isFalsy && !isZero) errors[requiredField] = 'Required';
  });

  return errors;
}



// WEBPACK FOOTER //
// ./app/utils/required-validation.js